import Image from 'app/Components/Shared/Image/image';
import React, {useState} from 'react';
import {isMobile} from 'react-device-detect';
import Config from '../../../Config';
import images from './images/images';
import './InfoBlock.scss';

const InfoBlock = ({context, iContent}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const headerText = isMobile ? iContent.mobileHeaderText?.value : iContent.desktopHeaderText?.value;
  const headerColor = isMobile ? iContent.mobileHeaderColor?.value : iContent.desktopHeaderColor?.value;
  const paragraphText = isMobile ? iContent.mobileParagraphText?.value : iContent.desktopParagraphText?.value;
  const paragraphColor = isMobile ? iContent.mobileParagraphColor?.value : iContent.desktopParagraphColor?.value;
  const backgroundMedia = isMobile ? iContent.mobileBackgroundMedia : iContent.desktopBackgroundMedia;
  const backgroundColor = isMobile ? iContent.mobileBackgroundColor?.value : iContent.desktopBackgroundColor?.value;
  const toggleButtonText = iContent.toggleButtonText?.value || 'Read More';

  // Clean paragraph richtext
  const cleanParagraphText = (text) => {
    if (!text) return text;
    return text.replace(/<pre[^>]*>/gi, '<div>').replace(/<\/pre>/gi, '</div>');
  };

  const cleanedParagraphText = cleanParagraphText(paragraphText);
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const buttonText = isExpanded ? 'סגור קריאה' : toggleButtonText;

  const getMediaInfo = () => {
    if (!backgroundMedia?.value) return null;

    const mediaUrl = backgroundMedia.value?.url
      ? Config.epiBaseUrl + backgroundMedia.value.url
      : null;

    const contentType = backgroundMedia.expandedValue?.contentType?.[0] || '';
    const isVideo = contentType.toLowerCase().includes('video') || mediaUrl?.toLowerCase().endsWith('.mp4');

    return {url: mediaUrl, isVideo};
  };

  const mediaInfo = getMediaInfo();

  const getBlockClasses = () => {
    let classes = ['info-block'];
    if (iContent.margin?.value) classes.push(iContent.margin.value);
    if (iContent.padding?.value) classes.push(iContent.padding.value);
    if (isExpanded) classes.push('info-block--expanded');
    return classes.join(' ');
  };

  const getBlockStyles = () => {
    return {
      backgroundColor: iContent.backgroundColor?.value || 'transparent',
      opacity: iContent.blockOpacity?.value || 1,
    };
  };

  return (
    <div className={getBlockClasses()} style={getBlockStyles()}>
      <div className={`info-block__container ${isExpanded ? 'info-block__container--expanded' : 'info-block__container--collapsed'}`}>
        {mediaInfo?.url && (
          <div
            className={`info-block__media ${isExpanded ? 'info-block__media--expanded' : 'info-block__media--collapsed'}`}
            style={{backgroundColor: backgroundColor || 'transparent'}}
          >
            {mediaInfo.isVideo ? (
              <video
                className="info-block__media-video"
                autoPlay
                loop
                playsInline
                muted
              >
                <source src={mediaInfo.url} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              <Image className="info-block__media-image"
                src={mediaInfo.url}
                alt={headerText || 'Background media'} />
            )}
          </div>
        )}

        <div className={`info-block__content ${isExpanded ? 'info-block__content--expanded' : ''}`}>
          {/* Header */}
          {headerText && (
            <div
              className="info-block__header"
              style={{color: headerColor || '#000000'}}
            >
              {headerText}
            </div>
          )}

          {cleanedParagraphText && (
            <div
              className={`info-block__paragraph ${isExpanded ? 'info-block__paragraph--expanded' : 'info-block__paragraph--collapsed'}`}
              style={{color: paragraphColor || '#333333'}}
              dangerouslySetInnerHTML={{__html: cleanedParagraphText}}
            />
          )}

          <button
            className="info-block__toggle-button"
            onClick={handleToggle}
            aria-expanded={isExpanded}
          >
            {buttonText}{' '}
            <Image src={images.whiteArrow}
              alt="toggle"
              className={`info-block__toggle-icon ${isExpanded ? 'info-block__toggle-icon--up' : 'info-block__toggle-icon--down'}`} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoBlock;

